import * as types from './mutation_types'

export default {
  [types.RESET] (state) {
    Object.assign(state, {
      isLoading: false,
      userDataItems: [],
      itemTypesItems: [],
      itemCategoriesItems: [],
      priceGroupsItems: [],
      itemBrandsItems: [],
      measuresItems: [],
      vatRatesItems: [],
      casesItems: []
    })
  },

  [types.SET_USERDATA_ITEMS] (state, userDataItems) {
    Object.assign(state, { userDataItems })
  },

  [types.SET_ITEMTYPES_ITEMS] (state, itemTypesItems) {
    Object.assign(state, { itemTypesItems })
  },
  [types.SET_ITEMBRANDS_ITEMS] (state, itemBrandsItems) {
    Object.assign(state, { itemBrandsItems })
  },
  [types.SET_ITEMCATEGORIES_ITEMS] (state, itemCategoriesItems) {
    Object.assign(state, { itemCategoriesItems })
  },
  [types.SET_PRICEGROUPS_ITEMS] (state, priceGroupsItems) {
    Object.assign(state, { priceGroupsItems })
  },

  [types.SET_MEASURES_ITEMS] (state, measuresItems) {
    Object.assign(state, { measuresItems })
  },

  [types.SET_VATRATES_ITEMS] (state, vatRatesItems) {
    Object.assign(state, { vatRatesItems })
  },

  [types.SET_CASES_ITEMS] (state, casesItems) {
    Object.assign(state, { casesItems })
  },

  [types.TOGGLE_LOADING] (state) {
    Object.assign(state, { isLoading: !state.isLoading })
  }
}
